import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';

const useStyles = makeStyles(theme => ({
  buttonProgress: {
    color: '#4caf50',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  }
}));

const AsyncButton = ({
  text,
  handleClick,
  loading,
  className = 'mx-auto mt-24 w-full',
  icon,
  color = 'secondary',
  type = 'submit',
  disabled = false,
  ...props
}) => {
  const classes = useStyles();

  return (
    <Button
      {...props}
      type={type}
      variant="contained"
      color={color}
      className={className}
      disabled={loading || disabled}
      startIcon={icon && <Icon>{icon}</Icon>}
      onClick={handleClick}>
      {text}
      {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
    </Button>
  );
};

export default AsyncButton;
